module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-25.4e18971b.png";